
import React from 'react';
import { motion } from 'framer-motion';

const HomePageHeader = () => (
  <header className="text-center mb-10">
    <motion.h1
      className="text-5xl md:text-6xl font-extrabold tracking-tight mb-3"
      style={{
        background: 'linear-gradient(to right, hsl(var(--primary)), hsl(var(--accent)))',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent'
      }}
      initial={{ y: -30, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 0.2, duration: 0.5 }}
    >
      Розклад Занять
    </motion.h1>
    <motion.p
      className="text-lg text-muted-foreground max-w-2xl mx-auto"
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 0.4, duration: 0.5 }}
    >
      Актуальний розклад занять для студентів та викладачів
    </motion.p>
  </header>
);

export default HomePageHeader;
